import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = (token, data) => {
    const {
        auth,
        config
    } = firebase;
    
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    // The server only accepts notifications from signed-in users
    if (!auth || !auth.currentUser) {
        return;
    }
    auth.currentUser.getIdToken()
    .then((idToken) => fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + idToken,
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    }))
    .then((response) => {

    })
    .catch((error) => {
        console.log(error)
    });
}